import "../StapleForm/StapleForm.scss";
import "./CustomForm.scss";
import { useState } from "react";
import axios from "axios";
import { API_URL } from "../../utils/axios";
import { Redirect } from "react-router-dom";

const CustomForm = ({
  setShowCookies,
  setShowConfections,
  setShowCakes,
  setImageUrl,
  imageUrl,
}) => {
  const showWidget = () => {
    console.log("i fire");
    let widget = window.cloudinary.createUploadWidget(
      {
        cloudName: `df9ul5qs5`,
        uploadPreset: `snpdah9c`,
        max_files: 1,
      },
      (error, result) => {
        if (!error && result && result.event === "success") {
          setImageUrl(result.info.url);
        }
      }
    );
    widget.open();
  };

  const [selection, setSelection] = useState("");
  const [quantity, setQuantity] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [details, setDetails] = useState("");
  const [submittedForm, setSubmittedForm] = useState(false);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleQuantityChange = (e) => {
    setQuantity(e.target.value);
  };

  const handleSelectionChange = (e) => {
    const val = e.target.value;
    if (val === "cookies") {
      setShowCookies(true);
      setShowConfections(false);
      setShowCakes(false);
    } else if (val === "confections") {
      setShowCookies(false);
      setShowConfections(true);
      setShowCakes(false);
    } else if (val === "cakes") {
      setShowCookies(false);
      setShowConfections(false);
      setShowCakes(true);
    }
    setSelection(val);
  };
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };
  const handleDateChange = (e) => {
    setDate(e.target.value);
  };
  const handleDetailsChange = (e) => {
    setDetails(e.target.value);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const custom = {
      selection: selection,
      quantity: quantity,
      name: name,
      email: email,
      phone: phone,
      date: date,
      details: details,
      customImage: imageUrl,
    };

    axios
      .post(API_URL + "/order/quotes", {
        ...custom,
      })
      .then((response) => setSubmittedForm(true))
      .catch((error) => console.log(error));
  };

  if (submittedForm) {
    return <Redirect to="/sent" />;
  }

  return (
    <form className="custom-form" onSubmit={handleSubmit}>
      <p className="custom-form__upload" onClick={showWidget}>
        Click here to upload a picture
      </p>
      <label htmlFor="categories">Pick One</label>

      <select
        id="categories"
        value={selection}
        onChange={handleSelectionChange}
      >
        <option value="">Please Select</option>
        <option value="cookies">Cookies</option>
        <option value="cakes">Cakes</option>
        <option value="confections">Confections</option>
      </select>
      <label htmlFor="quantity">QUANTITY</label>
      <input
        className="custom-form__input"
        type="text"
        id="quantity"
        name="quantity"
        placeholder="Dozens"
        value={quantity}
        onChange={handleQuantityChange}
      />
      <label htmlFor="nameInput">NAME</label>
      <input
        className="custom-form__input"
        type="text"
        id="nameInput"
        name="name"
        placeholder="Name"
        value={name}
        onChange={handleNameChange}
      />
      <label htmlFor="email">EMAIL ADDRESS</label>
      <input
        className="custom-form__input"
        type="text"
        id="email"
        name="email"
        placeholder="Email"
        value={email}
        onChange={handleEmailChange}
      />
      <label htmlFor="phone">PHONE NUMBER</label>
      <input
        className="custom-form__input"
        type="text"
        id="phone"
        name="phone"
        placeholder="Name"
        value={phone}
        onChange={handlePhoneChange}
      />
      <label htmlFor="date">PICK UP DATE</label>
      <input
        type="date"
        id="dafe"
        name="date"
        min="2020-12-01"
        max="2021-12-31"
        value={date}
        onChange={handleDateChange}
      />
      <label htmlFor="details">DETAILS</label>
      <textarea
        className="custom-form__details"
        id="details"
        name="details"
        placeholder="Extra important information i.e. allergies"
        value={details}
        onChange={handleDetailsChange}
      />

      <button className="custom-form__button">SUBMIT</button>
    </form>
  );
};

export default CustomForm;
